import * as React from "react";
import { useNotification } from "../../context/notification-provider";
import { useDialogs } from "../dialog/use-dialog";
import { deleteFilterOption } from "./service";
import { FilterOptionDetail } from "./types";

const FilterOptionDeleteDialog = ({
  selectedFilterOption,
  open,
  onClose,
}: {
  selectedFilterOption: FilterOptionDetail;
  open: boolean;
  onClose: () => void;
}) => {
  const { showNotification } = useNotification();
  const { confirm } = useDialogs();

  const hasOpenedRef = React.useRef(false);

  React.useEffect(() => {
    if (!open || hasOpenedRef.current) return;

    hasOpenedRef.current = true;

    const run = async () => {
      try {
        const result = await confirm(
          `Are you sure you want to delete the filter option "${selectedFilterOption.description}"? This action cannot be undone.`,
          {
            title: "Confirm Filter Option Deletion",
            okText: "Delete",
            cancelText: "Cancel",
            severity: "error",
          },
        );

        if (result === true) {
          try {
            await deleteFilterOption(selectedFilterOption.id);
            showNotification({
              message: "Filter option deleted successfully.",
              severity: "success",
              duration: 3000,
            });
          } catch (err) {
            showNotification({
              message: `Failed to delete filter option. Reason: ${(err as Error).message}`,
              severity: "error",
              duration: 3000,
            });
          }
        }
      } catch {
        showNotification({
          message: "Failed to show confirmation dialog.",
          severity: "error",
          duration: 3000,
        });
      } finally {
        onClose();
        hasOpenedRef.current = false;
      }
    };

    run();
  }, [open, confirm, selectedFilterOption, showNotification, onClose]);

  return null;
};

export default FilterOptionDeleteDialog;
